/*
 * @Author: 丨小小风离丨
 * @Date: 2024-04-22 16:46:39
 * @LastEditTime: 2024-04-22 17:13:06
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\components\statusTips\index.tsx
 * @Description: 
 */

function Index(props: any) {
    const {
        text = '',
        style
    } = props

    function hexToRGBA(hex, alpha) {
        // 将十六进制颜色值转换为 RGB
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);

        // 返回带有透明度的 RGBA 颜色值
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }


    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 2,
            padding: '0 4px',
            height: 20,
            fontSize: 14,
            color: '#0099ff',
            background: hexToRGBA(style?.color || '#0099ff', 0.1),
            ...style,
        }}>
            {
                text || '进行中'
            }
        </div>
    )
}

export default Index
